module.exports = __webpack_public_path__ + "static/media/video-demo.048511e5.gif";